import { IResponse } from '../../../model';
import { Estados } from '../../../operaciones';
import { ICardEdit } from '../../../operaciones/model/ICardEdit';
import ServiceBase from '../../../servicebase';

export default class CardService extends ServiceBase {
  getId = (data:{ tipo?: 'CO' | 'OP', codigo?: string | number }) : Promise<IResponse<number>> => 
    this.GetFetch<IResponse<number>>('entity/card/getid', data);

  get = (data:{ tipo?: 'CO' | 'OP', id?: number }) : Promise<IResponse<ICardEdit>> => 
    this.GetFetch<IResponse<ICardEdit>>('entity/card', data);

  /*
  update = (data: { tipo: string, id: number, updates: { field: string, value: any }[] }) : Promise<IResponse<unknown>> => 
    this.PutFetch<IResponse<unknown>>('entity/card', data);
  */

  estado = (data:{ tipo?: 'CO' | 'OP', id?: number, estado?: Estados }) : Promise<IResponse<unknown>> => 
    this.PutFetch<IResponse<unknown>>('entity/card/estado', data);
}
